'use client';

import { createContext, useContext } from 'react';

export type UserRole = 'viewer' | 'moderator' | 'admin' | null;

interface AuthContextValue {
  user: any;
  session: any;
  loading: boolean;
  role: UserRole;
  isAdmin: boolean;
  isModerator: boolean;
  signUp: (email: string, password: string, metadata?: any) => Promise<any>;
  signIn: (email: string, password: string) => Promise<any>;
  signOut: () => Promise<void>;
  getCurrentUser: () => Promise<any>;
  isEmailVerified: () => boolean;
  getUserProfile: () => Promise<any>;
}

const ADMIN_USER = {
  id: 'public-admin',
  email: 'admin@goliveafrica.media',
  role: 'admin',
};

const AuthContext = createContext<AuthContextValue>({} as AuthContextValue);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const value: AuthContextValue = {
    user: ADMIN_USER,
    session: { user: ADMIN_USER },
    loading: false,
    role: 'admin',
    isAdmin: true,
    isModerator: true,
    signUp: async () => ({}),
    signIn: async () => ({}),
    signOut: async () => {},
    getCurrentUser: async () => ADMIN_USER,
    isEmailVerified: () => true,
    getUserProfile: async () => ({ ...ADMIN_USER, role: 'admin' }),
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
